// Generated by BUCKLESCRIPT VERSION 2.2.0, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("bs-platform/lib/js/array.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Hashtbl = require("bs-platform/lib/js/hashtbl.js");
var Slugify = require("./slugify");
var Json_decode = require("@glennsl/bs-json/lib/js/src/Json_decode.bs.js");

function etat(json) {
  var str = Json_decode.string(json);
  switch (str) {
    case "AC" : 
        return /* Accepte */0;
    case "DI" : 
        return /* Discute */1;
    default:
      throw [
            Json_decode.DecodeError,
            "Unknown etat " + str
          ];
  }
}

function groupe(json) {
  var str = Json_decode.string(json);
  switch (str) {
    case "FI" : 
        return /* LaFranceInsoumise */1;
    case "GDR" : 
        return /* GaucheDemocrateEtRepublicaine */0;
    case "LR" : 
        return /* LesRepublicains */3;
    case "MODEM" : 
        return /* MouvementDemocrateEtApparentes */4;
    case "NG" : 
        return /* NouvelleGauche */5;
    case "NI" : 
        return /* NonInscrits */7;
    case "REM" : 
        return /* LaRepubliqueEnMarche */2;
    case "UDI-AGIR" : 
        return /* UdiAgirEtIndependants */6;
    default:
      throw [
            Json_decode.DecodeError,
            "Unknown groupe " + str
          ];
  }
}

function sortEnSeance(json) {
  var str = Json_decode.string(json);
  var slug = Curry._1(Slugify.slugify, str);
  switch (slug) {
    case "" : 
        return /* Depose */1;
    case "adopte" : 
        return /* Adopte */0;
    case "non-soutenu" : 
        return /* NonSoutenu */2;
    case "rejete" : 
        return /* Rejete */3;
    case "retire" : 
        return /* Retire */4;
    case "tombe" : 
        return /* Tombe */5;
    default:
      throw [
            Json_decode.DecodeError,
            "Unknown sortEnSeance " + slug
          ];
  }
}

function typeDiscussion(json) {
  var str = Json_decode.string(json);
  if (str === "projet de loi") {
    return /* ProjetDeLoi */0;
  } else {
    throw [
          Json_decode.DecodeError,
          "Unknown typeDiscussion " + str
        ];
  }
}

function auteur(json) {
  return /* record */[
          /* civilite */Json_decode.field("civilite", Json_decode.string, json),
          /* estRapporteur */Json_decode.field("estRapporteur", Json_decode.bool, json),
          /* estGouvernement */Json_decode.field("estGouvernement", Json_decode.bool, json),
          /* groupeTribunId */Json_decode.field("groupeTribunId", Json_decode.string, json),
          /* nom */Json_decode.field("nom", Json_decode.string, json),
          /* photoUrl */Json_decode.field("photoUrl", Json_decode.string, json),
          /* prenom */Json_decode.field("prenom", Json_decode.string, json),
          /* qualite */Json_decode.field("qualite", (function (param) {
                  return Json_decode.optional(Json_decode.string, param);
                }), json),
          /* tribunId */Json_decode.field("tribunId", Json_decode.string, json)
        ];
}

function cosignatairesMentionLibre(json) {
  return /* record */[/* titre */Json_decode.field("string", Json_decode.string, json)];
}

function amendement(json) {
  return /* record */[
          /* auteur */Json_decode.field("auteur", auteur, json),
          /* bibard */Json_decode.field("bibard", Json_decode.string, json),
          /* bibardSuffixe */Json_decode.field("bibardSuffixe", Json_decode.string, json),
          /* cosignataires */Json_decode.field("cosignataires", (function (param) {
                  return Json_decode.array(auteur, param);
                }), json),
          /* cosignatairesMentionLibre */Json_decode.field("cosignatairesMentionLibre", (function (param) {
                  return Json_decode.optional(cosignatairesMentionLibre, param);
                }), json),
          /* dispositif */Json_decode.field("dispositif", (function (param) {
                  return Json_decode.optional(Json_decode.string, param);
                }), json),
          /* etat */Json_decode.field("etat", etat, json),
          /* exposeSommaire */Json_decode.field("exposeSommaire", (function (param) {
                  return Json_decode.optional(Json_decode.string, param);
                }), json),
          /* legislature */Json_decode.field("legislature", Json_decode.$$int, json),
          /* numero */Json_decode.field("numero", Json_decode.string, json),
          /* numeroLong */Json_decode.field("numeroLong", Json_decode.string, json),
          /* numeroReference */Json_decode.field("numeroReference", Json_decode.string, json),
          /* organeAbrv */Json_decode.field("organeAbrv", Json_decode.string, json),
          /* place */Json_decode.field("place", Json_decode.string, json),
          /* placeReference */Json_decode.field("placeReference", Json_decode.string, json),
          /* sortEnSeance */Json_decode.field("sortEnSeance", sortEnSeance, json)
        ];
}

function amendementUpsertedWrapper(json) {
  return Json_decode.field("amendementUpserted", amendement, json);
}

function amendementWrapper(json) {
  return /* record */[
          /* alineaLabel */Json_decode.field("alineaLabel", Json_decode.string, json),
          /* amendement */Json_decode.field("amendement", (function (param) {
                  return Json_decode.optional(amendement, param);
                }), json),
          /* auteurGroupe */Json_decode.field("auteurGroupe", (function (param) {
                  return Json_decode.optional(groupe, param);
                }), json),
          /* auteurLabel */Json_decode.field("auteurLabel", Json_decode.string, json),
          /* discussionCommune */Json_decode.field("discussionCommune", Json_decode.string, json),
          /* discussionCommuneAmdtPositon */Json_decode.field("discussionCommuneAmdtPositon", Json_decode.string, json),
          /* discussionCommuneSsAmdtPositon */Json_decode.field("discussionCommuneSsAmdtPositon", Json_decode.string, json),
          /* discussionIdentique */Json_decode.field("discussionIdentique", Json_decode.string, json),
          /* discussionIdentiqueAmdtPositon */Json_decode.field("discussionIdentiqueAmdtPositon", Json_decode.string, json),
          /* discussionIdentiqueSsAmdtPositon */Json_decode.field("discussionIdentiqueSsAmdtPositon", Json_decode.string, json),
          /* missionLabel */Json_decode.field("missionLabel", Json_decode.string, json),
          /* numero */Json_decode.field("numero", Json_decode.string, json),
          /* parentNumero */Json_decode.field("parentNumero", Json_decode.string, json),
          /* place */Json_decode.field("place", Json_decode.string, json),
          /* position */Json_decode.field("position", Json_decode.string, json),
          /* sort */Json_decode.field("sort", sortEnSeance, json)
        ];
}

function billPage(json) {
  return /* record */[
          /* body */Json_decode.field("body", Json_decode.string, json),
          /* numero */Json_decode.field("numero", Json_decode.string, json),
          /* slug */Json_decode.field("slug", Json_decode.string, json),
          /* titre */Json_decode.field("titre", (function (param) {
                  return Json_decode.optional(Json_decode.string, param);
                }), json)
        ];
}

function config(json) {
  return /* record */[
          /* apiUrl */Json_decode.field("apiUrl", Json_decode.string, json),
          /* appTitle */Json_decode.field("appTitle", Json_decode.string, json),
          /* appUrl */Json_decode.field("appUrl", Json_decode.string, json),
          /* twitterName */Json_decode.field("twitterName", Json_decode.string, json)
        ];
}

function division(json) {
  return /* record */[
          /* place */Json_decode.field("place", Json_decode.string, json),
          /* position */Json_decode.field("position", Json_decode.string, json)
        ];
}

function discussion(json) {
  var billPages = Json_decode.field("pages", (function (param) {
          return Json_decode.array(billPage, param);
        }), json);
  var billPageBySlug = Hashtbl.create(/* Some */[/* true */1], billPages.length);
  return /* record */[
          /* amendements */Json_decode.field("amendements", (function (param) {
                  return Json_decode.array(amendementWrapper, param);
                }), json),
          /* bibard */Json_decode.field("bibard", Json_decode.string, json),
          /* bibardSuffixe */Json_decode.field("bibardSuffixe", Json_decode.string, json),
          /* divisions */Json_decode.field("divisions", (function (param) {
                  return Json_decode.array(division, param);
                }), json),
          /* legislature */Json_decode.field("legislature", Json_decode.$$int, json),
          /* numeroProchainADiscuter */Json_decode.field("numeroProchainADiscuter", (function (param) {
                  return Json_decode.optional(Json_decode.string, param);
                }), json),
          /* organe */Json_decode.field("organe", Json_decode.string, json),
          /* pages */($$Array.iter((function (billPage) {
                    return Hashtbl.add(billPageBySlug, billPage[/* slug */2], billPage);
                  }), billPages), billPageBySlug),
          /* titre */Json_decode.field("titre", Json_decode.string, json),
          /* typeDiscussion */Json_decode.field("type", typeDiscussion, json)
        ];
}

function discussionWrapper(json) {
  return Json_decode.field("discussion", discussion, json);
}

function ordreDuJourItem(json) {
  return /* record */[
          /* textBibard */Json_decode.field("textBibard", Json_decode.string, json),
          /* textBibardSuffixe */Json_decode.field("textBibardSuffixe", Json_decode.string, json),
          /* textTitre */Json_decode.field("textTitre", Json_decode.string, json)
        ];
}

function ordreDuJourWrapper(json) {
  return Json_decode.field("ordreDuJour", (function (param) {
                return Json_decode.array(ordreDuJourItem, param);
              }), json);
}

function prochainADiscuter(json) {
  return /* record */[
          /* bibard */Json_decode.field("bibard", Json_decode.string, json),
          /* bibardSuffixe */Json_decode.field("bibardSuffixe", Json_decode.string, json),
          /* legislature */Json_decode.field("legislature", Json_decode.$$int, json),
          /* nbrAmdtRestant */Json_decode.field("nbrAmdtRestant", Json_decode.$$int, json),
          /* numAmdt */Json_decode.field("numAmdt", Json_decode.string, json),
          /* organeAbrv */Json_decode.field("organeAbrv", Json_decode.string, json)
        ];
}

function prochainADiscuterUpsertedWrapper(json) {
  return Json_decode.field("prochainADiscuterUpserted", prochainADiscuter, json);
}

exports.etat = etat;
exports.groupe = groupe;
exports.sortEnSeance = sortEnSeance;
exports.typeDiscussion = typeDiscussion;
exports.auteur = auteur;
exports.cosignatairesMentionLibre = cosignatairesMentionLibre;
exports.amendement = amendement;
exports.amendementUpsertedWrapper = amendementUpsertedWrapper;
exports.amendementWrapper = amendementWrapper;
exports.billPage = billPage;
exports.config = config;
exports.division = division;
exports.discussion = discussion;
exports.discussionWrapper = discussionWrapper;
exports.ordreDuJourItem = ordreDuJourItem;
exports.ordreDuJourWrapper = ordreDuJourWrapper;
exports.prochainADiscuter = prochainADiscuter;
exports.prochainADiscuterUpsertedWrapper = prochainADiscuterUpsertedWrapper;
/* Slugify Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/decoders.re
// module id = 115
// module chunks = 0